import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');
        let config = {
            slidesPerView: "auto",
            spaceBetween: 40,
            freeMode: {
                enabled: true,
                sticky: false,
                momentum: true,
            },
            scrollbar: {
                el: this.element.querySelector(".swiper-scrollbar"),
                draggable: true,
                hide: false,
            },
            observer: true,
            breakpoints: {
                1000: {
                    spaceBetween: 60
                },
                1200: {
                    spaceBetween: 140
                }
            }
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({FreeMode, Scrollbar}) => {
                Swiper.use([FreeMode, Scrollbar]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}